/**
 * Determines the appropriate login page path based on user roles
 * @param {Array<string>} roles - Array of user roles
 * @returns {string} - The login page path
 */
export function getLoginPageByRole(roles) {
  if (!roles || roles.length === 0) {
    return "/login";
  }

  const normalizedRoles = roles.map((r) => r.toLowerCase());

  // Priority order: platform_admin > company_admin/company_user > university_admin/university_student > default (student/professional)
  if (normalizedRoles.includes("platform_admin")) {
    return "/platform/login";
  } else if (
    normalizedRoles.includes("company_admin") ||
    normalizedRoles.includes("company_user")
  ) {
    return "/company/login";
  } else if (
    normalizedRoles.includes("university_admin") ||
    normalizedRoles.includes("university_student")
  ) {
    return "/university/login";
  }

  // Default to student/professional login
  return "/login";
}
